/* eslint-disable no-sequences */
import axios from "axios";
import { apiUrl_forCart } from "./constants";

const CancelToken = axios.CancelToken;

// add cart
export let cancelAddCouponApi;
export async function addCoupon(headers, coupon_code, temp_order_id, customer_id) {
    if (headers && coupon_code && temp_order_id && customer_id) {
        const coupon = await axios.put(apiUrl_forCart + "apply/coupon",
            { coupon_code, temp_order_id, customer_id },
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    cancelAddCouponApi = c;
                }),
            }
        );
        return coupon;
    } else {
        console.log("Please add required parameters");
    }
}